import React from 'react';
import { RelativeRowCellLayoutProps, RelativeRowGroupLayoutProps } from 'ui-builder';
import styles from './RelativeRow.module.scss';

export function RelativeRowGroupLayout(
  props: RelativeRowGroupLayoutProps,
) {
  return (
    <div
      // eslint-disable-next-line react/no-array-index-key
      className={`${styles.row} ${props.className}`}
    >
      {props.children}
    </div>
  );
}

export function RelativeRowCellLayout(props: RelativeRowCellLayoutProps) {
  const centered = props.isCentered ? styles.centered : '';

  return (
    <div
      className={`${styles.cell} ${props.className} x${props.weight} ${centered}`}
    >
      {props.children}
    </div>
  );
}
